import { render } from "./AdminRoles.vue?vue&type=template&id=891faa6a"
import script from "./AdminRoles.vue?vue&type=script&lang=js"
export * from "./AdminRoles.vue?vue&type=script&lang=js"

import "./AdminRoles.vue?vue&type=style&index=0&id=891faa6a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__